import Skeleton from 'react-loading-skeleton';

export const renderSkeletons = (
  count: number,
  className: string,
  style?: React.CSSProperties
) =>
  Array.from({ length: count }).map((_, i) => (
    <div key={i} className={className} style={style}>
      <Skeleton />
    </div>
  ));
